import gql from 'graphql-tag';

export const PLEX_POST_LINK_METADATA_FRAGMENT = gql`
  fragment plexPostLinkMetadata on PlexPostLinkMetadata {
    post {
      id
      permalink
      title
      plex {
        id
        name
      }
    }
  }
`;
